import ApplyResultSample from '@common/applyResultSample';
import { useMatchProfilesComplete } from '@repository/profiles/useProfile';
import Analyzing from '@components/acca/results/result/applyResult/analyzing';
import AnalysisError from '@components/acca/results/result/applyResult/analysisError';
import { useGetMatchConfigStatus } from '@repository/match';
import { useUserInfo } from '@repository/auth/useUserInfo';
import ApplyResultContent from './applyResultContent';
import { PHSAnalysisType } from '@domain/constant/phsAnalysisType';
import classNames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classNames.bind(styles);

interface ApplyResultProps {
  sn: number;
  resultState: PHSAnalysisType | null;
}

const ApplyResult = ({ sn, resultState }: ApplyResultProps) => {
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { data: ProfilesCompleteInfoData } = useMatchProfilesComplete();
  const { data: matchingConfig } = useGetMatchConfigStatus(isLogin);

  if (!ProfilesCompleteInfoData || !matchingConfig) return null;

  const getResult = () => {
    //프로필 기본 미 완성시 or 추천 서비스 on이 아닐 경우
    if (!ProfilesCompleteInfoData.profileRequiredCompleteYn || !matchingConfig.matchingConfigYn)
      return <ApplyResultSample />;

    switch (resultState) {
      // 분석 대기, 분석중
      case 'IN_PROGRESS':
        return <Analyzing />;
      // 분석 완료
      case 'COMPLETED':
        return <ApplyResultContent sn={sn} />;
      // 분석 오류
      case 'FAILED':
        return <AnalysisError />;
      // 없는 결과표
      default:
        return null;
    }
  };

  return <div className={cx('resultWrap')}>{getResult()}</div>;
};

export default ApplyResult;
